import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { BaseUpdateComponent, BaseDataService, ModalService, YtKontrolaJmbg, NotificationService } from 'yt-ng-framework';
import { CompanyRegister } from "./company-register";
import { ActivatedRoute, Router } from "@angular/router";
// import { NotificationsService } from "angular2-notifications";
import { TranslateService } from "@ngx-translate/core";
import { FormGroup, Validators } from "@angular/forms";
import { TipKomitenta } from "src/app/lookups/tip-komitenta/tip-komitenta";
// import { ToastrService } from "ngx-toastr";

@Component({
    selector: 'company-register-update',
    templateUrl: './company-register-update.component.html'
})
export class CompanyRegisterUpdateComponent
 extends BaseUpdateComponent<CompanyRegister>
 implements OnInit {
    constructor(
        protected activatedRoute: ActivatedRoute,
        protected baseDataService: BaseDataService,
        // protected notificationsService: NotificationsService,
        protected toastrService: NotificationService,
        protected translateService: TranslateService,
        protected modalService: ModalService,
        protected router: Router,
        protected changeDetectorRef: ChangeDetectorRef,
    ){
        super(activatedRoute
            , baseDataService
            , toastrService
            , translateService
            , modalService
            , router
        );
    }

    ngOnInit(){
        super.ngOnInit();
        this.addValidatorToFc('Naziv', Validators.required, 'required', 'FIRMA.NAZIV.VALIDATION.REQUIRED');
        this.baseFormGroup.get('Naziv').updateValueAndValidity();

        this.addValidatorToFc("Naziv", Validators.maxLength(200), 'maxlength', 'FIRMA.NAZIV.VALIDATION.MAXLENGTH');
        // this.addValidatorToFc('TipKomitentaID', Validators.required, 'required', 'FIRMA.TIPKOMITENTA.VALIDATION.REQUIRED');
        this.addValidatorToFc('Adresa', Validators.required, 'required', 'FIRMA.ADRESA.VALIDATION.REQUIRED');
        this.addValidatorToFc("Adresa", Validators.maxLength(200), 'maxlength', 'FIRMA.ADRESA.VALIDATION.MAXLENGTH');
        this.addValidatorToFc('MestoID', Validators.required, 'required', 'FIRMA.MESTO.VALIDATION.REQUIRED');

        // this.addValidatorToFc("Pib", Validators.maxLength(9), 'maxlength', 'KOMITENT.PIB.VALIDATION.MAXLENGTH');
        // this.addValidatorToFc("MaticniBroj", Validators.maxLength(8), 'maxlength', 'KOMITENT.MATICNIBROJ.VALIDATION.MAXLENGTH');
        // this.addValidatorToFc("Jmbg", Validators.maxLength(13), 'maxlength', 'KOMITENT.JMBG.VALIDATION.MAXLENGTH');
        // this.addValidatorToFc("Jmbg",YtKontrolaJmbg, 'jmbgControl', 'FW.KONTROLAPOMODULU.VALIDATION.MODUL11');
        // this.addValidatorToFc("BrojPoljoprivrednogGazdinstva", Validators.maxLength(30), 'maxlength', 'KOMITENT.BROJGAZDINSTVA.VALIDATION.MAXLENGTH');

        // this.baseFormGroup.patchValue({TipKomitentaID: 1});

        // this.baseFormGroup.setValidators(CheckByTipKomitenta('TipKomitentaID','Pib','MaticniBroj','Jmbg','BrojPoljoprivrednogGazdinstva'));
        // this.baseFormGroup.updateValueAndValidity();
    }

    OnTipKomitentaSelected(tipKomitenta: TipKomitenta){
        setTimeout(() => {
        if(tipKomitenta == null){
            this.baseFormGroup.get('Pib').disable();
            this.baseFormGroup.get('Pib').updateValueAndValidity();
            // this.baseFormGroup.get('Pib').clearValidators();

            this.baseFormGroup.get('MaticniBroj').disable();
            this.baseFormGroup.get('MaticniBroj').updateValueAndValidity();
            // this.baseFormGroup.get('MaticniBroj').clearValidators();

            this.baseFormGroup.get('Jmbg').disable();
            this.baseFormGroup.get('Jmbg').updateValueAndValidity();
            // this.baseFormGroup.get('Jmbg').clearValidators();

            this.baseFormGroup.get('BrojPoljoprivrednogGazdinstva').disable();
            this.baseFormGroup.get('BrojPoljoprivrednogGazdinstva').updateValueAndValidity();
            // this.baseFormGroup.get('BrojPoljoprivrednogGazdinstva').clearValidators();
            
        }
        else if(tipKomitenta.GenericName == 'PD'){
            this.baseFormGroup.get('Pib').enable();
            this.baseFormGroup.get('Pib').updateValueAndValidity();
            // this.addValidatorToFc("Pib", Validators.maxLength(9), 'maxlength', 'FIRMA.PIB.VALIDATION.MAXLENGTH');
            // this.addValidatorToFc("Pib", Validators.required, 'required', 'FIRMA.PIB.VALIDATION.REQUIRED');

            this.baseFormGroup.get('MaticniBroj').enable();
            this.baseFormGroup.get('MaticniBroj').updateValueAndValidity();
            // this.addValidatorToFc("MaticniBroj", Validators.required, 'required', 'FIRMA.MATICNIBROJ.VALIDATION.REQUIRED');
            // this.addValidatorToFc("MaticniBroj", Validators.maxLength(8), 'maxlength', 'FIRMA.MATICNIBROJ.VALIDATION.MAXLENGTH');

            this.baseFormGroup.patchValue({Jmbg: null, BrojPoljoprivrednogGazdinstva: null});
            this.baseFormGroup.get('Jmbg').disable();
            this.baseFormGroup.get('Jmbg').updateValueAndValidity();
            // this.baseFormGroup.get('Jmbg').clearValidators();
            
            this.baseFormGroup.get('BrojPoljoprivrednogGazdinstva').disable();
            this.baseFormGroup.get('BrojPoljoprivrednogGazdinstva').updateValueAndValidity();
            // this.baseFormGroup.get('BrojPoljoprivrednogGazdinstva').clearValidators();
        }
        else if(tipKomitenta.GenericName == 'PG'){
            this.baseFormGroup.patchValue({Pib: null, MaticniBroj: null});
            this.baseFormGroup.get('Pib').disable();
            this.baseFormGroup.get('Pib').updateValueAndValidity();
            // this.baseFormGroup.get('Pib').clearValidators();

            this.baseFormGroup.get('MaticniBroj').disable();
            this.baseFormGroup.get('MaticniBroj').updateValueAndValidity();
            // this.baseFormGroup.get('MaticniBroj').clearValidators();

            this.baseFormGroup.get('Jmbg').enable();
            this.baseFormGroup.get('Jmbg').updateValueAndValidity();
            // this.addValidatorToFc("Jmbg", Validators.maxLength(13), 'maxlength', 'FIRMA.JMBG.VALIDATION.MAXLENGTH');
            // this.addValidatorToFc("Jmbg",YtKontrolaJmbg, 'jmbgControl', 'FW.KONTROLAPOMODULU.VALIDATION.MODUL11');
            // this.addValidatorToFc("Jmbg", Validators.required, 'required', 'FIRMA.JMBG.VALIDATION.REQUIRED');
            
            this.baseFormGroup.get('BrojPoljoprivrednogGazdinstva').enable();
            this.baseFormGroup.get('BrojPoljoprivrednogGazdinstva').updateValueAndValidity();
            // this.addValidatorToFc("BrojPoljoprivrednogGazdinstva", Validators.maxLength(30), 'maxlength', 'FIRMA.BROJGAZDINSTVA.VALIDATION.MAXLENGTH');
            // this.addValidatorToFc("BrojPoljoprivrednogGazdinstva", Validators.required, 'required', 'FIRMA.BROJPOLJOPRIVREDNOGGAZDINSTVA.VALIDATION.REQUIRED');
        }
        else if(tipKomitenta.GenericName == 'Ostalo'){
            this.baseFormGroup.get('Pib').enable();
            this.baseFormGroup.get('Pib').updateValueAndValidity();
            // this.addValidatorToFc("Pib", Validators.maxLength(9), 'maxlength', 'FIRMA.PIB.VALIDATION.MAXLENGTH');
            // this.addValidatorToFc("Pib", Validators.required, 'required', 'FIRMA.PIB.VALIDATION.REQUIRED');

            this.baseFormGroup.get('MaticniBroj').enable();
            this.baseFormGroup.get('MaticniBroj').updateValueAndValidity();
            // this.addValidatorToFc("MaticniBroj", Validators.required, 'required', 'FIRMA.MATICNIBROJ.VALIDATION.REQUIRED');
            // this.addValidatorToFc("MaticniBroj", Validators.maxLength(8), 'maxlength', 'FIRMA.MATICNIBROJ.VALIDATION.MAXLENGTH');

            this.baseFormGroup.get('Jmbg').enable();
            this.baseFormGroup.get('Jmbg').updateValueAndValidity();
            // this.addValidatorToFc("Jmbg", Validators.maxLength(13), 'maxlength', 'FIRMA.JMBG.VALIDATION.MAXLENGTH');
            // this.addValidatorToFc("Jmbg",YtKontrolaJmbg, 'jmbgControl', 'FW.KONTROLAPOMODULU.VALIDATION.MODUL11');
            // this.addValidatorToFc("Jmbg", Validators.required, 'required', 'FIRMA.JMBG.VALIDATION.REQUIRED');

            this.baseFormGroup.get('BrojPoljoprivrednogGazdinstva').enable();
            this.baseFormGroup.get('BrojPoljoprivrednogGazdinstva').updateValueAndValidity();
            // this.addValidatorToFc("BrojPoljoprivrednogGazdinstva", Validators.maxLength(30), 'maxlength', 'FIRMA.BROJGAZDINSTVA.VALIDATION.MAXLENGTH');
            // this.addValidatorToFc("BrojPoljoprivrednogGazdinstva", Validators.required, 'required', 'FIRMA.BROJPOLJOPRIVREDNOGGAZDINSTVA.VALIDATION.REQUIRED');
        }
        this.baseFormGroup.setValidators(CheckByTipKomitenta('TipKomitentaID','Pib','MaticniBroj','Jmbg','BrojPoljoprivrednogGazdinstva'));
        this.baseFormGroup.updateValueAndValidity();
    
        this.changeDetectorRef.detectChanges();
        // this.changeDetectorRef.markForCheck();

        }, 100)
    }


}

function CheckByTipKomitenta(tipKomitentaIDKey:string, pibKey: string, maticniBrojKey: string, jmbgKey: string, brojGazdinstvaKey: string){
    return (group: FormGroup): {[key : string]: any} =>{
     let tipKomitenaID = group.controls[tipKomitentaIDKey].value;
     let pib = group.controls[pibKey].value;
     let maticniBroj = group.controls[maticniBrojKey].value;
     let jmbg = group.controls[jmbgKey].value;
     let brojGazdinstva = group.controls[brojGazdinstvaKey].value;
 
     if (tipKomitenaID==null && pib==null && maticniBroj==null)
         return null;
     else{
         if (tipKomitenaID==1 && (pib=="" || maticniBroj=="" || pib==null || maticniBroj==null))
             return { checkControls :{valid:false, message: 'KOMITENT.TIPKOMITENTA.PRIVREDNODRUSTVO.VALIDATION'}};
         if (tipKomitenaID==2 && (jmbg=="" || brojGazdinstva=="" || jmbg==null || brojGazdinstva ==null))
             return { checkControls :{valid:false, message: 'KOMITENT.TIPKOMITENTA.GAZDINSTVO.VALIDATION'}};
         }  
     }    
 }